import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
    ProSidebar,
    Menu,
    MenuItem,
    SidebarFooter,
    SidebarContent,
} from "react-pro-sidebar";
import { FaHome, FaCog, FaClipboardList, FaFileImport, FaEuroSign} from "react-icons/fa";
import { HiUserGroup } from "react-icons/hi";
import bgImage from "./../../../images/bg1.jpg";
import { withNamespaces } from "react-i18next";
import history from './../../../history'

export class Aside extends React.Component {

    handleToggleSidebar = async (e) => {
        await this.props.mapState("USER_MAP_SETTINGS", {column: "asideToggled", value: !this.props.user.user_web_properties.settings.asideToggled});
    }

    logout = () => {
        history.replace("/");
        sessionStorage.clear();
    };

    render() {
        const { t } = this.props;
        return (
            <ProSidebar
                rtl={false}
                image={this.props.asideBg ? bgImage : ""}
                collapsed={this.props.user.user_web_properties.settings.asideColapsed}
                toggled={this.props.user.user_web_properties.settings.asideToggled}
                onToggle={(e) => this.handleToggleSidebar(e)}
                className="pro-sidebar-color"
            >
                <SidebarContent>
                    <Menu iconShape="circle">
                        <MenuItem
                            icon={<FaHome size={24} />}
                            active={history.location.pathname.includes("dashboard")}
                        >
                            <Link
                                to="/dashboard"
                                onClick={(e) => this.handleToggleSidebar(e)}
                            >
                                {t("Dashboard")}
                            </Link>
                        </MenuItem>

                        {this.props.user.roles.indexOf("POWERADMIN") > -1 ? (
                            <MenuItem 
                                icon={<HiUserGroup size={24} />}
                                active={history.location.pathname.includes("providers")}
                            >
                                <Link
                                    to="/providers"
                                    onClick={(e) => this.handleToggleSidebar(e)}
                                >
                                    {t("Providers")}
                                </Link>
                            </MenuItem>
                        ) : null}

                        {/* <MenuItem 
                            icon={<BsBriefcaseFill size={24} />}
                            active={window.location.href.includes("client")}
                        >
                            <Link
                                to="/client"
                                onClick={(e) => this.handleToggleSidebar(e)}
                            >
                                {t("Clients")}
                            </Link>
                        </MenuItem> */}

                        {this.props.user.roles.indexOf("POWERADMIN") > -1 ? (
                            <>
                                <MenuItem 
                                    icon={<FaClipboardList size={24} />}
                                    active={history.location.pathname.includes("codebook")}
                                >
                                    <Link
                                        to="/codebook"
                                        onClick={(e) => this.handleToggleSidebar(e)}
                                    >
                                        {t("Codebook")}
                                    </Link>
                                </MenuItem>
                                <MenuItem 
                                    icon={<FaFileImport size={24} />}
                                    active={history.location.pathname.includes("import")}
                                >
                                    <Link
                                        to="/import"
                                        onClick={(e) => this.handleToggleSidebar(e)}
                                    >
                                        {t("Import")}
                                    </Link>
                                </MenuItem>
                                <MenuItem 
                                    icon={<FaEuroSign size={24} />}
                                    active={history.location.pathname.includes("transaction")}
                                >
                                    <Link
                                        to="/transaction"
                                        onClick={(e) => this.handleToggleSidebar(e)}
                                    >
                                        {t("Transactions")}
                                    </Link>
                                </MenuItem>
                            </>
                        ) : null}
                        
                        <MenuItem 
                            icon={<FaCog size={24} />}
                            active={history.location.pathname.includes("settings")}
                        >
                            <Link
                                to="/settings"
                                onClick={(e) => this.handleToggleSidebar(e)}
                            >
                                {t("Settings")}
                            </Link>
                        </MenuItem>
                    </Menu>
                </SidebarContent>

                <SidebarFooter className="text-center"/>
            </ProSidebar>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data }),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withNamespaces()(Aside));
